document.documentElement.classList.add('js');

document.addEventListener('click', (e) => {
  const toggle = e.target.closest('[data-menu-toggle]');
  if (toggle) document.body.classList.toggle('menu-open');
  const close = e.target.closest('[data-menu-close]');
  if (close) document.body.classList.remove('menu-open');
});

document.addEventListener('change', (e) => {
  const select = e.target.closest('[data-variant-select]');
  if (!select) return;
  const option = select.options[select.selectedIndex];
  const form = select.closest('form');
  const idInput = form && form.querySelector('input[name="id"]');
  const price = document.querySelector('[data-product-price]');
  if (idInput) idInput.value = option.value;
  if (price && option.dataset.price) price.textContent = option.dataset.price;
});

async function addToCart(form){
  const btn=form.querySelector('[type="submit"]');
  if(btn){btn.disabled=true; btn.dataset.label=btn.textContent; btn.textContent='ADDING…';}
  try{
    const res=await fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)});
    if(!res.ok) throw new Error('Could not add item');
    window.location.href='/cart';
  }catch(err){
    alert(err.message || 'Something went wrong.');
    if(btn){btn.disabled=false;btn.textContent=btn.dataset.label||'ADD TO BAG';}
  }
}

document.addEventListener('submit',(e)=>{
  const form=e.target.closest('[data-ajax-cart-form]');
  if(!form) return;
  e.preventDefault();
  addToCart(form);
});